<template><slot /></template>

<script setup>
import { inject, onBeforeUnmount, watch, computed, toRefs } from 'vue';

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  value: {
    type: [String, Array],
    default: '',
  },
});

const emit = defineEmits(['update:value']);

const { value } = toRefs(props);
const getFieldValue = inject('form/getFieldValue', () => {});
const storeFieldValue = inject('form/storeFieldValue', () => {});
const deleteField = inject('form/deleteField', () => {});
const fieldValue = computed({
  get: () => getFieldValue(props.name) || value.value,
  set: value => storeFieldValue(props.name, value),
});

watch(
  value,
  value => {
    fieldValue.value = value;
  },
  { deep: true }
);

watch(
  fieldValue,
  value => {
    emit('update:value', value);
    fieldValue.value = value;
  },
  { immediate: true, deep: true }
);

onBeforeUnmount(() => {
  deleteField(props.name);
});
</script>

<script>
export default {
  compatConfig: { RENDER_FUNCTION: false },
};
</script>
